import CardTravelIcon from '@mui/icons-material/CardTravel';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

export function TripsNotFound() {
  return (
    <Container style={{ paddingTop: 20 }}>
      <Paper elevation={0}>
        <div style={{ textAlign: 'center', padding: 10 }}>
          <div
            style={{
              height: 80,
              width: 80,
              borderRadius: 80,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '40px auto',
              backgroundColor: '#f1f1f1',
            }}
          >
            <CardTravelIcon fontSize="large" color="secondary" />
          </div>

          <Typography variant="h5" style={{ margin: '40px auto' }}>
            There are currently no upcoming Trips. Please check back soon!
          </Typography>
        </div>
      </Paper>
    </Container>
  );
}
